import React from 'react';
import PropTypes from 'prop-types';

import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Close as CloseIcon,
  OpenInNew as ExtLinkIcon,
} from '@material-ui/icons';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { 
  fmtECRConsoleLink,
} from '../../utils/formatters';

import { 
  ECRIcon,
} from '../../aws';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '8px',
    whiteSpace: 'normal',
    height: 'auto',
  },
  label: {
    // display: 'flex',
    // flexGrow: 2,
    paddingTop: '4px',
    paddingBottom: '4px',
    width: 'calc(100% - 58px)',
    whiteSpace: 'normal',
  },
  info: {
    display: 'flex',
    flexFlow: 'column',
    //overflow: 'hidden',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
  },
  typography: {
  }
}));

const DEFAULT_REGION = 'us-west-2';

export default function ContainerChip(props) {
  const { owner, account, repo, image, maxWidth, region=DEFAULT_REGION } = props;
  const classes = useStyles();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [actionMessage, setActionMessage] = React.useState("");
  
  const effectiveRepoAcct=account==='unspecified'?'229688178637':account;
  const imageUri = `${effectiveRepoAcct}.dkr.ecr.${region}.amazonaws.com/${repo}:${image}`;
  const href = fmtECRConsoleLink(effectiveRepoAcct, repo);
  const displayRepoAcct=effectiveRepoAcct==='229688178637'?'TOOLS':
                        effectiveRepoAcct==='211439235829'?'DATALAKE':
                        effectiveRepoAcct===owner?'CLIENT':effectiveRepoAcct;

  const handleExtLink = () => {
    window.open(href,"_blank");
    handleCloseMenu();
  };

  const handleClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleActionPerformed = (message) => {
    setActionMessage(message);
    handleCloseMenu();
  };

  const clearActionMessage = () => {
    setActionMessage("");
  };


  return (
    <React.Fragment>
      <Chip
        classes={{ root: classes.root, label: classes.label }}
        variant="outlined"
        icon=<ECRIcon/>
        label={
          <div className={classes.info}>
            <div className={classes.name}>
              <Typography className={classes.typography} variant='inherit' color='primary'>
                {repo}
              </Typography>
            </div>
            <div className={classes.description}>
              <Typography className={classes.typography} variant='inherit' >
                {image}
              </Typography>
                <Chip label={displayRepoAcct} 
                  style={{ marginLeft: '8px', height: '16px', borderRadius: '6px', fontSize: '0.7rem' }}/>
            </div>
          </div>
        }
        onClick={handleClick}
        style={{ maxWidth }}
      />
      <Menu
        id="action-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        <CopyToClipboard 
            text={imageUri} 
            onCopy={() => handleActionPerformed('ECR Image URI copied to clipboard')}>
          <MenuItem>Copy ECR Image URI...</MenuItem>
        </CopyToClipboard>
        <CopyToClipboard 
            text={href} 
            onCopy={() => handleActionPerformed('ECR Console URL copied to clipboard')}>
          <MenuItem>Copy ECR Console URL...</MenuItem>
        </CopyToClipboard>
        <MenuItem onClick={handleExtLink}>View object in ECR Console&nbsp;<ExtLinkIcon fontSize="small"/></MenuItem>
      </Menu>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={actionMessage.length>0}
        autoHideDuration={3000}
        onClose={clearActionMessage}
        message={actionMessage}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={clearActionMessage}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </React.Fragment>
  );
}

ContainerChip.propTypes = {
  owner: PropTypes.string.isRequired,
  account: PropTypes.string.isRequired,
  repo: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
};

ContainerChip.defaultProps = {
};

